module.exports = __webpack_public_path__ + "static/img/35.84c7e214.jpeg";